import { Box, FormControlLabel, Grid, Switch } from '@material-ui/core';
import React from 'react'
import InfoIcon from "@material-ui/icons/Info";
import { useDispatch } from 'react-redux';
import { ContentFilterOptions } from 'src/utils/contentFilterOptions';
import { Controller } from 'react-hook-form';
import useContentFilterStyles from '../styles';
import { CustomChipTooltip } from 'src/components/features/CustomChipTooltip';
import { toggleShowPublic } from 'src/redux/actions';
import { useShouldShowSwitches, VisibilitySwitches } from 'src/hooks/contentFilters/switch/useShouldShowSwitches';
import { CustomSwitchLabel, CustomSwitchTooltipTitle } from './CustomSwitchTooltipTitle';
import { SwitchConfigInterface, SwitchFilterNames } from './helpers/switchTypes';
import { getSwitchesConfig } from './helpers/switchesConfig';

interface ContentSwitchesProps {
  entityName?: string;
  disabled: boolean;
  options: ContentFilterOptions;
  control: any;
  setValue: any;
  preSetValues: any,
  handleSwitchTrigger: ( {e, switchName, switchType, onChange, onExtraChange}: {
    e: React.ChangeEvent<HTMLInputElement>,
    switchName: SwitchFilterNames,
    switchType: "multi" | "one_only",
    onChange: (v: any) => void,
    onExtraChange?: (checked: boolean)=>void,
  }) => void;
}

function ContentSwitches({ entityName, disabled, setValue, control, handleSwitchTrigger, options, preSetValues }: ContentSwitchesProps) {
  const classes = useContentFilterStyles();
  const dispatch = useDispatch();

  const visibilitySwitches : VisibilitySwitches = useShouldShowSwitches(options, entityName ?? "");
  const switches: SwitchConfigInterface[] = getSwitchesConfig({ visibilitySwitches, onExtraChange: () => dispatch(toggleShowPublic()) })

  return (
    <Grid container spacing={2} justifyContent='space-evenly'>
      {[1, 2].map((col) => (
        <Grid item xs={12} md={6} key={`col-${col}`}>
          {switches
            .filter(({ column, condition }) => column === col && condition)
            .map(({ name, switchColor, switchType, onExtraChange }) => (
              <Box key={name} style={{ marginBottom: 8 }}>
                <Controller
                  name={name}
                  control={control}
                  render={({ onChange, value }) => (
                    <Box className={classes.controllerBox}>
                      <Box>
                        <FormControlLabel
                          className={classes.FormControlLabelSw}
                          control={
                            <Switch
                              checked={value}
                              onChange={(e) => handleSwitchTrigger({e, switchName: name, switchType, onChange, onExtraChange})}
                              color={switchColor}
                              disabled={disabled}
                            />
                          }
                          label={<CustomSwitchLabel switchName={name} isWLNetPremium={visibilitySwitches.isWLNetPremium}/>}
                        />
                      </Box>
                      <Box>
                        <CustomChipTooltip title={<CustomSwitchTooltipTitle switchName={name} isWLNetPremium = {visibilitySwitches.isWLNetPremium}/>}>
                          <InfoIcon className={classes.infoIconStyle} fontSize="medium" />
                        </CustomChipTooltip>
                      </Box>
                    </Box>
                  )}
                />
              </Box>
            ))}
        </Grid>
      ))}
    </Grid>
  );
}
export default ContentSwitches